import { admin } from '../constants';
import adminService from '../services/admin';

// fetch license request list
const fetchUserListRequest = () => ({
  type: admin.FETCH_USER_LIST_REQUEST
});

const fetchUserListSuccess = users => ({
  type: admin.FETCH_USER_LIST_SUCCESS,
  users
});

const fetchUserListFailure = error => ({
  type: admin.FETCH_USER_LIST_FAILED,
  error
});

export const fetchUserListStatusReset = () => ({
  type: admin.FETCH_USER_LIST_STATUS_RESET
});

export const fetchUserList = () => async (dispatch, getState) => {
  dispatch(fetchUserListRequest());

  let res;

  const token = getState().user.profile.token;

  try {
    res = await adminService.getUserList(token);

    if (typeof res === 'object') {
      if (res.status === 200) {
        dispatch(fetchUserListSuccess(res.data.Result));
      } else {
        const { status, statusText, data } = res.response;

        dispatch(
          fetchUserListFailure({
            response: res,
            status,
            statusText,
            data
          })
        );
      }
    }
  } catch (e) {
    dispatch(fetchUserListFailure(e));
  }

  return res;
};

// fetch license request list
const updateUserInfoRequest = () => ({
  type: admin.UPDATE_USER_INFO_REQUEST
});

const updateUserInfoSuccess = users => ({
  type: admin.UPDATE_USER_INFO_SUCCESS,
  users
});

const updateUserInfoFailure = error => ({
  type: admin.UPDATE_USER_INFO_FAILED,
  error
});

export const updateUserInfoStatusReset = () => ({
  type: admin.UPDATE_USER_INFO_STATUS_RESET
});

export const updateUserInfo = (email, data) => async (dispatch, getState) => {
  dispatch(updateUserInfoRequest());

  let res;

  const token = getState().user.profile.token;

  try {
    res = await adminService.updateUserInfo(token, email, data);

    if (typeof res === 'object') {
      if (res.status === 200) {
        res = await adminService.getUserList(token);

        dispatch(updateUserInfoSuccess(res.data.Result));
      } else {
        const { status, statusText, data } = res.response;

        dispatch(
          updateUserInfoFailure({
            response: res,
            status,
            statusText,
            data
          })
        );
      }
    }
  } catch (e) {
    dispatch(updateUserInfoFailure(e));
  }

  return res;
};
